/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import Footer from "./footer"
import "./layout.scss"

import brandLogo from "../images/fahr_erlebnis_weiss_transparent.png"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
          about
          email
          
          contact {
            mobile
            telephone
          }
          address
          opening {
            day
            hour
            sams
            samstag
          }
          author {
            name
            website
            position
          }
        }
      }
    }
  `)

  return (
    <div className="layout">
      {/* <Header siteTitle={data.site.siteMetadata.title} logo={brandLogo} /> */}
      <main>{children}</main>
      <Footer siteMetadata={data.site.siteMetadata} />
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
